module.exports = __webpack_public_path__ + "static/img/theme_list_icon01.b03c2a66.svg";